import {Person} from "./person.model";
import {NotificationTypeEnum} from "../enums/person/notification-type.enum";
import {NotificationFrequencyEnum} from "../enums/person/notification-frequency.enum";
import {PermissionTypeEnum} from "../enums/person/permission-type.enum";

export class User {
  id: number;
  sub: string;
  person: Person;
  notificationTypes: NotificationTypeEnum[];
  notificationFrequency: NotificationFrequencyEnum;
  permissions: PermissionTypeEnum[];
  personsSharedMailboxes: Person[];

  constructor(
    id: number,
    sub: string,
    person: Person,
    notificationTypes: NotificationTypeEnum[],
    notificationFrequency: NotificationFrequencyEnum,
    permissions: PermissionTypeEnum[],
    personsSharedMailboxes?: Person[]
  ) {
    this.id = id;
    this.sub = sub;
    this.person = person;
    this.notificationTypes = notificationTypes;
    this.notificationFrequency = notificationFrequency;
    this.permissions = permissions
    this.personsSharedMailboxes = personsSharedMailboxes;
  }
}
